var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "q-row",
    { staticClass: "dashboard-container", attrs: { gutter: 10 } },
    [
      _c("q-header"),
      _vm._v(" "),
      _c(_vm.getLeftColumn, { tag: "component" }),
      _vm._v(" "),
      _c(_vm.getRightColumn, { tag: "component" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }